@if (isSupportedLanguage$ | async) {
  @if (enablePre24HourWidget && isWithin24HoursOfCreation) {
    <fin-expedia-hotels-widget [order$]="order$"></fin-expedia-hotels-widget>
  } @else {
    <div class="relative rounded-large border white-bg overflow-hidden mr-large-b">
      <fin-mmb-hotels-deeplink-in-contentbox
        [order$]="order$"
        [isWithin24HoursOfCreation]="isWithin24HoursOfCreation"
      ></fin-mmb-hotels-deeplink-in-contentbox>
    </div>
  }
}
